export default __webpack_public_path__ + "static/media/walletIcon.205940a0.png";